<template>
    <div class="flex items-center justify-center py-3.5 bg-white border-b" :class="{ 'sticky top-0': fixed === true }">
        <div class="flex items-center justify-center text-a-black-292b2c text-16 font-light font-main">
            <img class="icon_info mr-1" src="../../../assets/icon/register/info.png" alt=""/> {{ title }}
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        title: {
            type: String
        },
        fixed: {
            type: Boolean
        }
    },
    setup: function () {

    }
})
</script>

<style lang="scss" scoped>
.icon_info {
    width: 17.1px;
    height: 16px;
}
</style>
